import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthUserService } from 'src/app/core/services/auth-user.service';
import { SharedModuleService } from 'src/app/core/services/shared-module.service';
import { StaticTextService } from 'src/app/core/services/static-text.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule]
})
export class ErrorPageComponent implements OnInit {
  mainHeadingValue: string = 'Error';
  isOpened: boolean = true;

  private sharedModuleService = inject(SharedModuleService);
  public staticTextService = inject(StaticTextService);
  private authUser = inject(AuthUserService);
  private router = inject(Router);

  ngOnInit(): void {
    this.isOpened = false;
    this.sharedModuleService.setNavbarHeading(this.mainHeadingValue);
  }

  returnToHome(): void {
    this.router.navigate(['/login']);
  }
}
